import Card from 'components/card/Card';
import DataTagList from 'components/data-tag-list/DataTagList';
import Heading from 'components/heading/Heading';
import TagLinkList from 'components/tag-link-list/TagLinkList';
import { ICategoryListItem } from 'source/NFR.types';

const CategoryListItem: React.FC<ICategoryListItem> = ({ cardData, linkTags }) => {
  // const [datesTextWidth, setDatesTextWidth] = useState();
  // const dateTextRef = useRef<>();

  // useEffect(() => {
  //   if (dateTextRef.current) {
  //     setDatesTextWidth(dateTextRef.current.offsetWidth);
  //   }
  // }, []);

  return (
    <div className="category-list-item">
      <Card {...cardData} />
      <div className="category-list-item--info-section">
        <div className="card-info-desktop">
          {cardData.preTitle && (
            <div className="card--date">
              <span className="card--date-dot" />
              <time dateTime={cardData.preTitle} className="card--date-text">
                {cardData.preTitle}
              </time>
            </div>
          )}

          {cardData.title && cardData.link && (
            <a className="card--title" href={cardData.link.url}>
              <Heading level={2}>{cardData.title}</Heading>
            </a>
          )}
          {cardData.dataTagList && <DataTagList list={cardData.dataTagList} />}

          {cardData.text && <p className="card--text">{cardData.text}</p>}
        </div>
        {linkTags && <TagLinkList {...linkTags} />}
      </div>
    </div>
  );
};

CategoryListItem.displayName = 'CategoryListItem';

export default CategoryListItem;
